import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import BagIcon from '../../../components/Icons/BagIcon';
import MoreInfoIcon from '../../../components/Icons/MoreInfoIcon';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
// import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import UserInfoFilterForm from '../../../components/Table/TableFilterForms/UserInfoFilterForm';
// import ViewBusinessProfileSlider from '../../../components/Table/TableSliderViews/ViewBusinessProfileSlider';
import {
  BUSINESS_PROFILE,
  DRIVER_INFORMATION,
} from '../../../routes/routeConstants';

const UserTable = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Table
        // border
        tableTitle='USER LIST'
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search Partner Name',
          rightAttr: [
            {
              type: 'filter',
              comp: <UserInfoFilterForm />,
            },
          ],
        }}
        tableHeader={{
          'Partner Name': 'name',
          'User Role': 'accountCreatorRole',
          Routes: 'typicalRoute',
          'Total Fleets': 'fleetSize',
          'Listed Drivers': 'totalDrivers',
          Status: 'status',
        }}
        tableDataSourceUrl='ba/v1/company'
        cellsCustomComp={{
          phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
          status: <StatusCell statusKey='status' hasDot />,
        }}
        moreOptionsComponents={[
          <ActionRow
            key='View Driver List'
            label='View Driver List'
            width='232px'
            icon={<MoreInfoIcon />}
            actionFn={async (data: any) =>
              navigate(`/${DRIVER_INFORMATION}/${data.id}/${data.name}`)
            }
          />,

          <ActionRow
            key='View business  profile'
            label='View business  profile'
            width='232px'
            icon={<BagIcon />}
            actionFn={async (data: any) =>
              navigate(
                `/${BUSINESS_PROFILE}/${encodeURIComponent(JSON.stringify(data))}`,
              )
            }
          />,
          // <ViewDetails
          //   key='View business  profile'
          //   label='View business  profile'
          //   width='232px'
          //   icon={<BagIcon />}
          //   sliderCompFn={(data: any) => (
          //     <ViewBusinessProfileSlider data={data} />
          //   )}
          // />,
        ]}
      />
    </Container>
  );
};

export default UserTable;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
